import { Navigate } from "react-router-dom";
import { SettingsTabId } from "@/store/pages/SettingsPageStore/types";
import { appRoutes } from "@/app/router/appRoutes";

export const SettingsRedirect = ({ tabId }: { tabId: SettingsTabId }) => {
  return <Navigate to={`${appRoutes.notesList({}).path}?settings=${tabId}`} replace />;
};
